module.exports = __webpack_public_path__ + "static/media/image_17.7f6718cd.png";